import './HomeComponents.css';

const FeatureCards = () => {
  return (
    <section className="feature-split-hero">
      <video className="feature-video-bg" autoPlay muted loop playsInline>
        <source src="/assets/vid 4.mp4" type="video/mp4" />
      </video>
      <div className="feature-split-container">
        <div className="feature-card">
          <div className="feature-badge">⚡ AI-Powered</div>
          <h2>Helpers & <span>Requester Matching</span></h2>
          <p className="feature-description">
            At the core of Olitask is an AI-driven matching engine that analyzes task type, skill requirements, ratings, availability, location proximity, and historical performance to connect each request to the most suitable helper. This improves fulfillment speed, completion success rate, and overall customer satisfaction.
          </p>
        </div>
        <div className="feature-card">
          <div className="feature-badge">💰 User-Driven Pricing</div>
          <h2>Affordability & <span>Flexible Pricing</span></h2>
          <p className="feature-description">
            A key advantage of Olitask is affordability and user-driven pricing. Requesters offer what they can reasonably manage, allowing the market to respond — reducing negotiation friction and saving time for both sides. This transparent, bid-free model encourages quick acceptance and faster task fulfillment.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;